import { getGallery } from '@wix/ambassador-progallery-v1-gallery/http';
import { State } from '@wix/ambassador-progallery-v1-gallery/types';
export const fetchProGalleryItems = async (httpClient, errorHandler, galleryId) => {
  try {
    const allGalleryItems = [];
    const LIMIT = 100;
    let offset = 0;
    let total;
    await errorHandler.withErrorHandler(async () => {
      do {
        const {
          data: {
            gallery
          }
        } = await httpClient.request(getGallery({
          galleryId,
          limit: LIMIT,
          offset,
          state: State.SAVED
        }));
        allGalleryItems.push(...((gallery == null ? void 0 : gallery.items) ?? []));
        total = (gallery == null ? void 0 : gallery.totalItemsCount) ?? 0;
        offset += LIMIT;
      } while (offset < total);
    }, {
      errorCodesMap: {}
    });
    return allGalleryItems;
  } catch (e) {
    throw e;
  }
};
//# sourceMappingURL=fetch-pro-gallery-items.js.map